var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"table-cell"},[_vm._v(" "+_vm._s(_vm.$t('medication.medication_name'))+" ")]),_c('td',{staticClass:"table-cell"},[_vm._v(" "+_vm._s(_vm.$t('medication.dose'))+" ")]),_c('td',{staticClass:"table-cell"},[_vm._v(" "+_vm._s(_vm.$t('medication.frequency'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }